import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=0f829640&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=0f829640&prod&lang=scss&scoped=true"
import style1 from "./Insurance.vue?vue&type=style&index=1&id=0f829640&prod&lang=scss&scoped=true"
import style2 from "./Insurance.vue?vue&type=style&index=2&id=0f829640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f829640",
  null
  
)

export default component.exports